/* Yake Karışık Koleksiyon — Pebble tema render katmanı.
   Backend (App Proxy /listing) karışık + filtreli ürün listesini JSON verir; kartlar Pebble'ın
   product-card yapısıyla üretilir → theme.css devralır. Hata/erişilemezlik halinde SSR yedek listeye DOKUNULMAZ.
   Özellik bayrakları (data.features): facets, sortMenu, swatches, quickBuy, backendFavorites, ratingStars. */
(function () {
  'use strict';

  function readConfig() {
    try { var n = document.querySelector('[data-yake-config]'); return n ? JSON.parse(n.textContent) : {}; } catch (_) { return {}; }
  }
  var CFG = readConfig();
  var STR = CFG.strings || {};
  var CARD = CFG.card || {};
  var FEATURES = null;
  var FEAT_DEFAULTS = { facets: true, sortMenu: true, swatches: true, quickBuy: true, backendFavorites: false, ratingStars: false };
  function feat(name) { if (FEATURES && name in FEATURES) return !!FEATURES[name]; return !!FEAT_DEFAULTS[name]; }
  var WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600];

  // ------------------------------------------------------------ yardımcılar
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] == null) continue;
      if (k === 'class') node.className = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') node.addEventListener(k.slice(2), attrs[k]);
      else node.setAttribute(k, attrs[k]);
    }
    (children || []).forEach(function (c) { if (c != null) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return node;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function locUrl(u) {
    if (!u || typeof u !== 'string') return u;
    var root = CFG.rootUrl || '/';
    if (root === '/' || u.charAt(0) !== '/') return u;
    var base = root.replace(/\/+$/, '');
    if (u === base || u.indexOf(base + '/') === 0) return u;
    return base + u;
  }
  function numId(gid) { var m = String(gid || '').match(/(\d+)\s*$/); return m ? m[1] : ''; }
  function fold(s) {
    return (s || '').toString().replace(/İ/g, 'i').replace(/I/g, 'i').toLowerCase().replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c');
  }

  // -- para (Shopify formatMoney portu) --
  function withFormat(cents, format) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fn(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands == null ? ',' : thousands; decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) number = 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re); var name = m ? m[1] : 'amount'; var v;
    switch (name) {
      case 'amount_no_decimals': v = fn(cents, 0); break;
      case 'amount_with_comma_separator': v = fn(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fn(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fn(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fn(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = fn(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fn(cents, 2, ' ', '.'); break;
      default: v = fn(cents, 2);
    }
    return format.replace(re, v);
  }
  function formatMoney(amountMajor) {
    var cents = Math.round((parseFloat(amountMajor) || 0) * 100);
    var fmt = (CFG.currencyCodeEnabled ? CFG.moneyWithCurrencyFormat : CFG.moneyFormat) || '{{amount}}';
    return withFormat(cents, fmt);
  }
  function moneyText(v) { try { return formatMoney(v).replace(/<[^>]*>/g, ''); } catch (e) { return ''; } }
  function currencySymbol() { return CFG.currencySymbol || '₺'; }

  // -- görseller --
  function withWidth(src, w) { try { var u = new URL(src, location.origin); u.searchParams.set('width', w); return u.href; } catch (_) { return src; } }
  function srcset(src, widths) { return widths.map(function (w) { return withWidth(src, w) + ' ' + w + 'w'; }).join(', '); }
  function imgEl(media, opts) {
    opts = opts || {};
    var a = { class: opts.class || '', src: withWidth(media.src, 600), srcset: srcset(media.src, opts.widths || WIDTHS), alt: media.alt || '', draggable: 'false', sizes: opts.sizes || CARD.mediaSizes || '(min-width: 768px) 25vw, 50vw' };
    if (media.width) a.width = media.width;
    if (media.height) a.height = media.height;
    if (opts.loading) a.loading = opts.loading;
    return el('img', a);
  }
  function frameRatio() {
    var r = String(CARD.aspectRatio || '1');
    if (r === 'auto' || r === 'adapt') return null;
    var p = r.split('/');
    if (p.length === 2) { var a = parseFloat(p[0]), b = parseFloat(p[1]); return b ? a / b : 1; }
    var n = parseFloat(r); return n > 0 ? n : 1;
  }

  // ------------------------------------------------------------ KART (Pebble product-card)
  function priceDisplay(p) {
    if (p.priceVaries) return { price: p.priceMin, compareAt: p.minVariantCompareAt, onSale: p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt, useFrom: true };
    return { price: p.priceMin, compareAt: p.minVariantCompareAt, onSale: p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt, useFrom: false };
  }
  function priceEl(p) {
    var d = priceDisplay(p);
    var wrap = el('product-price', { class: 'product-card__price' });
    var container = el('div', { class: 'price-container' + (d.onSale ? ' price--on-sale' : '') + (!p.available ? ' price--sold-out' : '') });
    var priceHtml = formatMoney(d.price);
    if (d.useFrom && STR.fromPrice) priceHtml = STR.fromPrice.replace('__PRICE__', priceHtml);
    var reg = el('div', { class: 'price__regular' });
    var regSpan = el('span', { class: 'price' }); regSpan.innerHTML = priceHtml; reg.appendChild(regSpan);
    container.appendChild(reg);
    var sale = el('div', { class: 'price__sale' });
    var saleSpan = el('span', { class: 'price price--sale' }); saleSpan.innerHTML = priceHtml; sale.appendChild(saleSpan);
    if (d.compareAt != null && d.price < d.compareAt) { var cmp = el('span', { class: 'compare-at-price' }); cmp.innerHTML = formatMoney(d.compareAt); sale.appendChild(cmp); }
    container.appendChild(sale);
    wrap.appendChild(container);
    return wrap;
  }
  function badgesEl(p) {
    var list = [];
    if (!p.available) {
      if (CARD.showSoldOutBadge) list.push(el('span', { class: 'badge badge--sold-out' }, [STR.soldOut || 'Tükendi']));
    } else if (CARD.showSaleBadge && p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt) {
      var text;
      if (CARD.saleBadgeType === 'percentage') text = (STR.discountBadge || '-__SAVINGS__').replace('__SAVINGS__', Math.round(((p.minVariantCompareAt - p.priceMin) / p.minVariantCompareAt) * 100) + '%');
      else if (CARD.saleBadgeType === 'fixed_amount') text = (STR.discountBadge || '-__SAVINGS__').replace('__SAVINGS__', moneyText(p.minVariantCompareAt - p.priceMin));
      else text = STR.onSale || 'İndirim';
      var b = el('span', { class: 'badge badge--sale' }); b.innerHTML = text; list.push(b);
    }
    if (!list.length) return null;
    var pb = el('product-badge', { class: 'product-card__badges', 'data-product-id': numId(p.id) });
    pb.appendChild(el('div', { class: 'product-badges product-badges--' + (CARD.badgeLayout || 'horizontal') }, list));
    return pb;
  }
  function quickLinks(p) {
    if (!feat('quickBuy')) return null;
    var hasView = CARD.showQuickView || CARD.showQuickViewMobile;
    var hasAdd = CARD.showQuickAdd || CARD.showQuickAddMobile;
    if (!hasView && !hasAdd) return null;
    var url = locUrl(p.url);
    var wrap = el('div', { class: 'product-card__actions flex flex-col items-end justify-end gap-1 absolute pointer-events-none' });
    var cs = CARD.quickAddColorScheme ? ' color-' + CARD.quickAddColorScheme : '';
    if (hasView) {
      var v = el('div', { class: 'quick-add yake-quick-link quick-add--view' + cs });
      var va = el('a', { href: url, class: 'btn btn--icon-only btn--primary quick-add__button--view', 'aria-label': STR.quickView || 'Hızlı bakış' });
      va.innerHTML = '<svg class="icon icon-search" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
      v.appendChild(va); wrap.appendChild(v);
    }
    if (hasAdd) {
      var c = el('div', { class: 'quick-add yake-quick-link quick-add--combine' + cs });
      var ca = el('a', { href: url, class: 'btn btn--primary quick-add__button quick-add__button--choose btn--icon-only', 'aria-label': STR.chooseOptions || 'Seçenekleri belirle' });
      ca.innerHTML = '<svg class="icon icon-cart" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 4h2l2.4 12h11L21 8H6.5"/><circle cx="9" cy="20" r="1.2"/><circle cx="17" cy="20" r="1.2"/></svg>';
      c.appendChild(ca); wrap.appendChild(c);
    }
    return wrap;
  }

  // --- Backend favorileri (kalp) ---
  var favSet = new Set(), favBase = '', favLoaded = false;
  function markHearts(scope) { (scope || document).querySelectorAll('[data-fav-id]').forEach(function (b) { b.classList.toggle('is-on', favSet.has(b.getAttribute('data-fav-id'))); }); }
  function toggleFav(btn, p) {
    if (!CFG.loggedIn) { window.location.href = CFG.loginUrl || '/account/login'; return; }
    var pid = btn.getAttribute('data-fav-id');
    var wasOn = btn.classList.contains('is-on');
    btn.classList.toggle('is-on', !wasOn);
    if (!wasOn) favSet.add(pid); else favSet.delete(pid);
    var body = new URLSearchParams({ product_id: pid, handle: p.handle || '', title: p.title || '', image: (p.featuredImage && p.featuredImage.src) || '', price: moneyText(p.priceMin) });
    fetch(favBase + '/favorites/toggle', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body: body.toString() })
      .then(function (r) { if (r.status === 401) { window.location.href = CFG.loginUrl || '/account/login'; throw 0; } return r.json(); })
      .then(function (res) { var on = !!res.favorited; btn.classList.toggle('is-on', on); if (on) favSet.add(pid); else favSet.delete(pid); })
      .catch(function () { btn.classList.toggle('is-on', wasOn); if (wasOn) favSet.add(pid); else favSet.delete(pid); });
  }
  function favButton(p) {
    if (!feat('backendFavorites')) return null;
    var pid = numId(p.id);
    var b = el('button', { type: 'button', class: 'ycol__fav' + (favSet.has(pid) ? ' is-on' : ''), 'aria-label': 'Favorilere ekle', 'data-fav-id': pid });
    b.innerHTML = '♥';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleFav(b, p); });
    return b;
  }
  function ratingEl(p) {
    if (!feat('ratingStars') || !p.rating || !p.rating.count) return null;
    var pct = Math.max(0, Math.min(100, (p.rating.average || 0) / 5 * 100));
    var w = el('div', { class: 'ycol__rating', title: p.rating.average + ' / 5' });
    w.innerHTML = '<span class="ycol__rating-bg">★★★★★<span class="ycol__rating-fg" style="width:' + pct + '%">★★★★★</span></span><span class="ycol__rating-count">(' + p.rating.count + ')</span>';
    return w;
  }

  function renderCard(p, position) {
    if (!p.url) p.url = '/products/' + p.handle;
    var url = locUrl(p.url);
    var style = CARD.style || 'standard';
    var card = el('product-card', { class: 'block product-card product-card--standard product-card--style-' + style + (style === 'card' && CARD.colorScheme ? ' color-' + CARD.colorScheme + ' overflow-hidden' : ''), handle: p.handle });
    card.appendChild(el('a', { href: url, class: 'product-card__link focus-visible--inset absolute inset-0', ref: 'productCardLink', 'aria-label': p.title || '' }));
    var wrapper = el('div', { class: 'product-card__wrapper flex flex-col product-card--has-quick-add' });

    // medya
    var ratio = frameRatio();
    var img = p.featuredImage;
    var ikinci = p.secondaryImage;
    /* 15 Eki 2026: bazı ürünlerde ilk görsel yatay ölçü tablosu (1024x652), ürün fotoğrafı ikinci sırada →
       ilk görsel belirgin yatay + ikinci dikeyse kartta ikinci görsel ana görsel olur (tablo üzerine gelince de çıkmaz). */
    if (img && ikinci && img.width && img.height && ikinci.width && ikinci.height && img.width / img.height > 1.15 && ikinci.height > ikinci.width) { img = ikinci; ikinci = null; }
    var imgRatio = img && img.width && img.height ? img.width / img.height : null;
    var useRatio = ratio || imgRatio || 1;
    var fit = 'cover';
    if (ratio && imgRatio) { var rel = imgRatio / ratio; if (rel > 0.75 && rel < 1.34) fit = 'contain'; }
    var media = el('div', { class: 'product-card__media media-hover--scale relative media-mask-clip' + (CARD.showSecondImage && ikinci ? ' product-card__media--has-second-image' : '') + (fit === 'contain' ? ' product-card__media--contain' : ''), style: '--ratio: ' + useRatio + ';' });
    var mlink = el('a', { href: url, ref: 'cardGalleryLink', 'aria-label': p.title || '', tabindex: '-1' });
    if (img) {
      var m1 = el('div', { class: 'media product-card__image product-card__image--first', style: '--ratio: ' + useRatio + ';' });
      m1.appendChild(imgEl(img, { class: 'media__image media-hover__element w-full product-card-main-image', loading: position > 4 ? 'lazy' : null }));
      mlink.appendChild(m1);
      if (CARD.showSecondImage && ikinci) {
        var m2 = el('div', { class: 'media product-card__image product-card__image--second', style: '--ratio: ' + useRatio + ';' });
        m2.appendChild(imgEl(ikinci, { class: 'media__image media-hover__element w-full', loading: 'lazy' }));
        mlink.appendChild(m2);
      }
    } else {
      mlink.appendChild(el('div', { class: 'media media--placeholder' }));
    }
    media.appendChild(mlink);
    var badges = badgesEl(p); if (badges) media.appendChild(badges);
    var fav = favButton(p); if (fav) media.appendChild(fav);
    var ql = quickLinks(p); if (ql) media.appendChild(ql);
    wrapper.appendChild(media);

    // içerik
    var align = CARD.contentAlignment || 'flex-start';
    var textAlign = align === 'center' ? 'center' : align === 'flex-end' ? 'right' : 'left';
    var content = el('div', { class: 'product-card__content' + (style === 'card' ? ' flex items-end justify-between' : ''), style: '--content-alignment: ' + align + ';' });
    var cw = el('div', { class: 'product-card__content--wrapper flex flex-col text-' + textAlign });
    if ((CARD.showVendor && p.vendor) || (CARD.showType && p.productType)) {
      var metas = el('div', { class: 'product-card__metas' });
      if (CARD.showVendor && p.vendor) metas.appendChild(el('a', { class: 'product-card__meta reversed-link', href: locUrl(p.vendorUrl || (CFG.vendorUrls && CFG.vendorUrls[p.vendor]) || ('/collections/vendors?q=' + encodeURIComponent(p.vendor))) }, [el('span', { class: 'reversed-link__text' }, [p.vendor])]));
      if (CARD.showType && p.productType) metas.appendChild(el('a', { class: 'product-card__meta reversed-link', href: locUrl('/collections/types?q=' + encodeURIComponent(p.productType)) }, [el('span', { class: 'reversed-link__text' }, [p.productType])]));
      cw.appendChild(metas);
    }
    cw.appendChild(el('a', { class: 'product-card__title text-wrap reversed-link', href: url, ref: 'productTitleLink', 'aria-label': p.title || '' }, [el('span', { class: 'reversed-link__text' }, [p.title || ''])]));
    cw.appendChild(priceEl(p));
    var rk = renkKutu(p, img, url); if (rk) cw.appendChild(rk);
    var rt = ratingEl(p); if (rt) cw.appendChild(rt);
    content.appendChild(cw);
    if (style === 'card' && (CARD.showQuickAdd || CARD.showQuickAddMobile) && feat('quickBuy')) {
      var qa = el('div', { class: 'product-card__quick-add !bg-none' + (CARD.quickAddColorScheme ? ' color-' + CARD.quickAddColorScheme : '') });
      var qaw = el('div', { class: 'quick-add yake-quick-link quick-add--combine' });
      var qal = el('a', { href: url, class: 'btn btn--primary quick-add__button quick-add__button--choose btn--icon-only btn--small', 'aria-label': STR.chooseOptions || '' });
      qal.innerHTML = '<svg class="icon" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.6"/></svg>';
      qaw.appendChild(qal); qa.appendChild(qaw); content.appendChild(qa);
    }
    wrapper.appendChild(content);
    card.appendChild(wrapper);
    var li = el('li', { class: 'product-grid__item', 'data-product-id': numId(p.id) });
    li.appendChild(card);
    return li;
  }

  /* 15 Eki 2026 (Sefa): koleksiyon kartlarında da renk kutucukları — snippets/ys-renk-kutucuk.liquid ile aynı
     işaretleme/sınıflar (ys-renk-kutucuk.css + .js hover). Renk seçeneği yoksa etiketten / başlığın başından renk,
     o da yoksa "Tek renk". Tema ayarları > Ürün kartı > Renk kutucukları. */
  var RENK_ADLARI = ['Yağ Yeşili', 'Haki Yeşil', 'Koyu Yeşil', 'Açık Mavi', 'Bebe Mavi', 'Buz Mavi', 'Koyu Lacivert', 'Rose Gold', 'Kahverengi', 'Antrasit', 'Lacivert', 'Kırmızı', 'Turuncu', 'Fuşya', 'Pudra', 'Bordo', 'Pembe', 'Somon', 'Mercan', 'Hardal', 'Siyah', 'Beyaz', 'İndigo', 'Indigo', 'Mavi', 'Yeşil', 'Haki', 'Mint', 'Sarı', 'Mor', 'Lila', 'Leylak', 'Kahve', 'Taba', 'Camel', 'Bej', 'Krem', 'Ekru', 'Kemik', 'Taş', 'Vizon', 'Gri', 'Füme', 'Gümüş', 'Altın', 'Petrol', 'Leopar', 'Nude', 'Ten', 'Zebra', 'Desenli', 'Çok Renkli', 'Multicolor', 'Black', 'White', 'Navy', 'Blue', 'Red', 'Green', 'Grey', 'Gray', 'Beige', 'Brown', 'Pink', 'Purple', 'Yellow', 'Orange', 'Khaki'];
  function trUst(s) { return (s || '').toString().replace(/i/g, 'İ').replace(/ı/g, 'I').toUpperCase(); }
  function genis(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function renkTuret(p) {
    var tags = (p.tags || []).map(trUst);
    for (var i = 0; i < RENK_ADLARI.length; i++) { if (tags.indexOf(trUst(RENK_ADLARI[i])) > -1) return RENK_ADLARI[i]; }
    var bas = trUst(p.title) + ' ';
    for (var j = 0; j < RENK_ADLARI.length; j++) { if (bas.indexOf(trUst(RENK_ADLARI[j]) + ' ') === 0) return RENK_ADLARI[j]; }
    return 'Tek renk';
  }
  function renkKutucugu(href, ad, gorsel, cokRenk, aktif, etiket) {
    var a = el('a', { href: href, class: 'ys-renk__k' + (aktif ? ' is-aktif' : ''), title: ad, 'aria-label': etiket });
    if (gorsel && cokRenk) { a.setAttribute('data-img', genis(gorsel.src, 600)); a.setAttribute('data-srcset', genis(gorsel.src, 400) + ' 400w, ' + genis(gorsel.src, 800) + ' 800w'); }
    var g = el('span', { class: 'ys-renk__g' });
    if (gorsel) g.appendChild(el('img', { src: genis(gorsel.src, 96), alt: '', loading: 'lazy', width: '48', height: '48' }));
    a.appendChild(g);
    if (!cokRenk) a.appendChild(el('span', { class: 'ys-renk__ad' }, [ad]));
    return a;
  }
  function renkKutu(p, anaGorsel, url) {
    var R = CFG.renk || {};
    if (!R.goster) return null;
    var limit = parseInt(R.limit, 10) || 4;
    var opt = (p.options || []).filter(function (o) { var n = (o.name || '').toLowerCase().trim(); return n === 'renk' || n === 'color' || n === 'colour' || n === 'цвет' || n === 'لون'; })[0];
    if (!opt) {
      if (!R.tek || !anaGorsel) return null;
      var ad = renkTuret(p);
      return el('div', { class: 'ys-renk ys-renk--tek' }, [renkKutucugu(url, ad, anaGorsel, false, true, 'Renk: ' + ad)]);
    }
    var vals = opt.values || [];
    if (vals.length < (R.tek ? 1 : 2)) return null;
    var cok = vals.length > 1;
    var wrap = el('div', { class: 'ys-renk' + (cok ? '' : ' ys-renk--tek') });
    vals.slice(0, limit).forEach(function (v, i) {
      var sw = (p.swatches || []).filter(function (s) { return s.value === v && s.image; })[0];
      /* 15 Eki: sunucu bazen değeri "[object Object]" gönderiyor → sayılar tutuyorsa sırayla eşleştir */
      if (!sw && (p.swatches || []).length === vals.length && p.swatches[i] && p.swatches[i].image) sw = p.swatches[i];
      var gor = (sw && sw.image) || (i === 0 ? anaGorsel : null);
      wrap.appendChild(renkKutucugu(sw && sw.url ? locUrl(sw.url) : url, v, gor, cok, i === 0, opt.name + ': ' + v));
    });
    if (vals.length > limit) wrap.appendChild(el('a', { href: url, class: 'ys-renk__fazla', 'aria-label': '+' + (vals.length - limit) }, ['+' + (vals.length - limit)]));
    /* 15 Eki: görseli eksik kutucuk varsa ys-renk-kutucuk.js ürün bilgisinden tamamlar */
    if (cok && wrap.querySelectorAll('.ys-renk__k:not([data-img])').length) { wrap.setAttribute('data-ys-eksik', ''); wrap.setAttribute('data-ys-urun', p.handle || ''); wrap.setAttribute('data-ys-secenek', opt.name); }
    return wrap;
  }

  // ------------------------------------------------------------ FİLTRELER
  function facetBox(title, body, open) {
    var d = el('details', { class: 'ycol__facet' });
    if (open) d.setAttribute('open', '');
    d.appendChild(el('summary', null, [el('span', null, [title])]));
    var b = el('div', { class: 'ycol__facet-body' });
    b.appendChild(body);
    d.appendChild(b);
    return d;
  }
  function listFacet(values, selected, onToggle) {
    var wrap = el('div', { class: 'ycol__facet-list flex flex-col gap-2' });
    var MAX = 12;
    values.forEach(function (v, i) {
      var id = 'yf-' + Math.random().toString(36).slice(2, 9);
      var input = el('input', { type: 'checkbox', id: id, value: v.value });
      if (selected.indexOf(v.value) >= 0) input.checked = true;
      input.addEventListener('change', function () { onToggle(v.value, input.checked); });
      var label = el('label', { class: 'ycol__check', for: id }, [input, el('span', null, [v.value]), el('span', { class: 'ycol__check-count' }, ['(' + v.count + ')'])]);
      if (i >= MAX) label.hidden = true;
      wrap.appendChild(label);
    });
    if (values.length > MAX) {
      var more = el('button', { type: 'button', class: 'ycol__show-more' }, [STR.showMore || 'Daha fazla göster']);
      more.addEventListener('click', function () { wrap.querySelectorAll('label[hidden]').forEach(function (l) { l.hidden = false; }); more.remove(); });
      wrap.appendChild(more);
    }
    return wrap;
  }
  /* 15 Eki 2026: Yake Store liste sunucusu renk kodu (v.swatch) göndermiyor → canlı Yake Store temasındaki
     ad→renk tablosu (aynı değerler). İki renk adı geçerse yarım/yarım; bilinmeyen ad gri kalır. */
  var TR_COLORS={siyah:"#111111",beyaz:"#ffffff",kirmizi:"#e0202a",kirmiz:"#e0202a",mavi:"#1f4ed8",lacivert:"#0a1f5c",yesil:"#1f9d3a",sari:"#f5d020",turuncu:"#f08020",mor:"#7b2fbe",pembe:"#f06ea9",gri:"#8a8a8a",kahve:"#6b4423",kahverengi:"#6b4423",bordo:"#7c1f2e",bej:"#d8c3a5",ekru:"#d6cdb7",krem:"#f3ead3",vizon:"#9a8478",haki:"#6b6b3a",antrasit:"#3a3a3a",fume:"#5a5a5a",gumus:"#c0c0c0",altin:"#d4af37",tas:"#cbb994",indigo:"#3f3f8f",petrol:"#1f6f6f",fusya:"#d6248f",somon:"#fa8072",murdum:"#5b2a4a",turkuaz:"#1bb5b5",nar:"#9c1f2e",camel:"#c19a6b",kemik:"#e7dcc6",buz:"#dbe6e8",mint:"#9fe2bf",lila:"#c8a2c8",yavruagzi:"#f7b39b",kiremit:"#b04a2f",hardal:"#c9a227",vual:"#cdb7a5",sutlu:"#e9dcc9",acik:null,koyu:null,neon:null,navy:"#0a1f5c",black:"#111111",white:"#ffffff",red:"#e0202a",blue:"#1f4ed8",green:"#1f9d3a",beige:"#d8c3a5",brown:"#6b4423",burgundy:"#7c1f2e",pink:"#f06ea9",grey:"#8a8a8a",gray:"#8a8a8a",ecru:"#d6cdb7",khaki:"#6b6b3a",cream:"#f3ead3",taba:"#a67b5b",saks:"#4863a0",pudra:"#f0c8c8",zumrut:"#2e8b57",hasir:"#e3c98c",ham:"#d8cdb8",sampanya:"#f1ddbf",visne:"#911e42",menekse:"#7b3f9f",fistik:"#93c572",mercan:"#ff7f50",lavanta:"#b497bd",nude:"#e3bc9a",ten:"#e3bc9a",tarcin:"#7b3f1d",kestane:"#5b3a29",kavunici:"#f4a460",limon:"#f7e463",bronz:"#cd7f32",safir:"#0f52ba",yakut:"#9b111e",toprak:"#8a5a44",kar:"#ffffff",fil:"#9a9a9a",gulkurusu:"#c4888c"};
  function foldTr(s) { return (s || '').toString().replace(/İ/g, 'i').replace(/I/g, 'i').toLowerCase().replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c'); }
  function renkArka(label) {
    var m = [];
    foldTr(label).split(/[^a-z]+/).filter(Boolean).forEach(function (w) { if (TR_COLORS[w]) m.push(TR_COLORS[w]); });
    if (m.length >= 2) return 'linear-gradient(to right, ' + m[0] + ' 50%, ' + m[1] + ' 50%)';
    return m.length === 1 ? m[0] : null;
  }
  function swatchFacet(values, selected, onToggle) {
    var wrap = el('div', { class: 'ycol__swatches' });
    values.forEach(function (v) {
      var id = 'yf-' + Math.random().toString(36).slice(2, 9);
      var input = el('input', { type: 'checkbox', id: id, value: v.value });
      if (selected.indexOf(v.value) >= 0) input.checked = true;
      input.addEventListener('change', function () { onToggle(v.value, input.checked); });
      var bg = v.swatch || renkArka(v.value) || '#e5e5e5';
      var label = el('label', { class: 'ycol__swatch', for: id, title: v.value + ' (' + v.count + ')' }, [input, el('span', { class: 'ycol__swatch-box', style: 'background: ' + bg + ';', 'aria-hidden': 'true' }), el('span', { class: 'ycol__swatch-name' }, [v.value]), el('span', { class: 'ycol__check-count' }, ['(' + v.count + ')'])]);
      wrap.appendChild(label);
    });
    return wrap;
  }
  function priceFacet(price, state, apply) {
    var min = price.min || 0, max = price.max || 0;
    var minInput = el('input', { class: 'form-control', type: 'number', min: String(Math.floor(min)), max: String(Math.ceil(max)), value: state.price_min, placeholder: String(Math.floor(min)), 'aria-label': STR.price || 'Fiyat' });
    var maxInput = el('input', { class: 'form-control', type: 'number', min: String(Math.floor(min)), max: String(Math.ceil(max)), value: state.price_max, placeholder: String(Math.ceil(max)), 'aria-label': STR.price || 'Fiyat' });
    var wrap = el('div', { class: 'ycol__price' }, [el('span', null, [currencySymbol()]), minInput, el('span', null, [STR.priceRangeTo || '–']), el('span', null, [currencySymbol()]), maxInput]);
    var commit = function () { state.price_min = minInput.value; state.price_max = maxInput.value; apply(true); };
    minInput.addEventListener('change', commit);
    maxInput.addEventListener('change', commit);
    return wrap;
  }
  function availabilityFacet(state, apply) {
    var id = 'yf-avail';
    var input = el('input', { type: 'checkbox', id: id, value: '1' });
    if (state.available === '1') input.checked = true;
    input.addEventListener('change', function () { state.available = input.checked ? '1' : ''; apply(true); });
    return el('label', { class: 'ycol__switch', for: id }, [input, el('span', null, [STR.inStockOnly || 'Sadece stokta'])]);
  }

  function productsCountText(total) {
    var forms = STR.productsCountForms;
    if (forms) {
      var cat = 'other';
      try { cat = new Intl.PluralRules(CFG.locale || 'tr').select(total); } catch (e) {}
      var tpl = forms[cat] || forms.other || '';
      if (tpl) return tpl.replace(/\d[\d.,]*/, String(total));
    }
    return total + ' ürün';
  }

  // ------------------------------------------------------------ init (her section)
  function initContainer(root) {
    var proxy = root.getAttribute('data-yake-proxy');
    favBase = (proxy || '').replace(/\/listing$/, '');
    var collection = root.getAttribute('data-yake-collection');
    var fixedVendor = root.getAttribute('data-yake-fixed-vendor') || '';
    var fixedType = root.getAttribute('data-yake-fixed-type') || '';
    /* 5 Eki 2026: sunucu koleksiyonu tanımıyorsa (0 ürün) ama Shopify'da ürün varsa kurtarma */
    var shopifyCount = parseInt(root.getAttribute('data-yake-shopify-count') || '0', 10);
    var singleVendor = root.getAttribute('data-yake-single-vendor') || '';
    var rescued = false;
    var pageSize = parseInt(root.getAttribute('data-yake-page-size') || '24', 10);
    if (!proxy || !collection) return;

    /* 15 Eki 2026 (Sefa): sahibinden gibi aynı sayfada kategori seçimi — ağaç Liquid'den (kategori menüsü) */
    var KAT = null;
    try { var katEl = root.querySelector('[data-ycol-kategori]'); if (katEl) KAT = JSON.parse(katEl.textContent.replace(/,\s*([\]}])/g, '$1')); } catch (e) { KAT = null; }
    if (KAT) KAT.kok.c = KAT.c;
    var tabanKoleksiyon = collection;
    function katYol(h) {
      if (!KAT) return [];
      if (KAT.kok.h === h) return [KAT.kok];
      for (var i = 0; i < KAT.c.length; i++) {
        var a = KAT.c[i]; if (a.h === h) return [KAT.kok, a];
        for (var j = 0; j < (a.c || []).length; j++) if (a.c[j].h === h) return [KAT.kok, a, a.c[j]];
      }
      return [];
    }
    var gridEl = root.querySelector('[data-yake-grid]');
    var facetsEl = root.querySelector('[data-yake-facets]');
    var activeEl = root.querySelector('[data-yake-active-facets]');
    var activeCount = root.querySelector('[data-yake-active-count]');
    var pagEl = root.querySelector('[data-yake-pagination]');
    var countEl = root.querySelector('[data-yake-count]');
    var emptyEl = root.querySelector('[data-yake-empty]');
    var sortWrap = root.querySelector('[data-yake-sort]');
    var sortSelect = root.querySelector('[data-yake-sort-select]');
    var filterToggle = root.querySelector('[data-yake-filter-toggle]');
    var clearBtn = root.querySelector('[data-yake-clear-all]');

    function readState() {
      var p = new URLSearchParams(location.search);
      var options = {};
      Array.from(p.keys()).forEach(function (k) { if (k.indexOf('option_') === 0) options[k.slice(7)] = p.getAll(k).filter(Boolean); });
      return { page: Math.max(1, parseInt(p.get('page') || '1', 10) || 1), vendor: p.getAll('vendor').filter(Boolean), product_type: p.getAll('product_type').filter(Boolean), tag: p.getAll('tag').filter(Boolean), options: options, price_min: p.get('price_min') || '', price_max: p.get('price_max') || '', available: p.get('available') || '', sort: p.get('sort_by') || '', kategori: p.get('kategori') || '' };
    }
    function writeState(state, push) {
      var p = new URLSearchParams(location.search);
      var setMulti = function (k, arr) { p.delete(k); (arr || []).filter(Boolean).forEach(function (v) { p.append(k, v); }); };
      var setOne = function (k, v) { if (v) p.set(k, v); else p.delete(k); };
      setMulti('vendor', state.vendor); setMulti('product_type', state.product_type); setMulti('tag', state.tag);
      setOne('price_min', state.price_min); setOne('price_max', state.price_max); setOne('available', state.available); setOne('sort_by', state.sort); setOne('kategori', state.kategori);
      Array.from(p.keys()).filter(function (k) { return k.indexOf('option_') === 0; }).forEach(function (k) { p.delete(k); });
      Object.keys(state.options).forEach(function (name) { setMulti('option_' + name, state.options[name]); });
      if (state.page > 1) p.set('page', state.page); else p.delete('page');
      history[push ? 'pushState' : 'replaceState']({}, '', location.pathname + (p.toString() ? '?' + p.toString() : ''));
    }
    function buildQuery(state) {
      var p = new URLSearchParams();
      p.set('collection', (state.kategori && katYol(state.kategori).length) ? state.kategori : collection); p.set('page', state.page); p.set('page_size', pageSize);
      if (CFG.locale) p.set('locale', CFG.locale);
      if (fixedVendor) p.append('vendor', fixedVendor); /* 2 Eki 2026: /collections/vendors?q=X */
      if (fixedType) p.append('product_type', fixedType);
      state.vendor.forEach(function (v) { p.append('vendor', v); });
      state.product_type.forEach(function (v) { p.append('product_type', v); });
      state.tag.forEach(function (v) { p.append('tag', v); });
      if (state.price_min) p.set('price_min', state.price_min);
      if (state.price_max) p.set('price_max', state.price_max);
      if (state.available || CFG.hideSoldOut) p.set('available', '1'); /* 2 Eki 2026: tükenenler gizli */
      if (state.sort) p.set('sort_by', state.sort);
      Object.keys(state.options).forEach(function (name) { state.options[name].forEach(function (v) { p.append('option_' + name, v); }); });
      return p.toString();
    }
    function activeTotal(state) {
      var n = (state.kategori ? 1 : 0) + state.vendor.length + state.product_type.length + state.tag.length + (state.available === '1' && !CFG.hideSoldOut ? 1 : 0) + ((state.price_min || state.price_max) ? 1 : 0);
      Object.keys(state.options).forEach(function (k) { n += state.options[k].length; });
      return n;
    }

    function renderGrid(items, append) {
      var offset = append ? gridEl.children.length : 0;
      if (!append) gridEl.innerHTML = '';
      if (!items.length && !append) { if (emptyEl) emptyEl.hidden = false; return; }
      if (emptyEl) emptyEl.hidden = true;
      var frag = document.createDocumentFragment();
      items.forEach(function (p, i) { frag.appendChild(renderCard(p, offset + i + 1)); });
      gridEl.appendChild(frag);
      if (window.YakeCurrency && window.YakeCurrency.refresh) window.YakeCurrency.refresh(gridEl);
    }

    function kategoriFacet(state, apply) {
      var secili = state.kategori || tabanKoleksiyon;
      var yol = katYol(secili); if (!yol.length) yol = [KAT.kok];
      var dugum = yol[yol.length - 1];
      var liste = (dugum.c && dugum.c.length) ? dugum.c : (yol.length > 1 ? (yol[yol.length - 2].c || []) : []);
      var ustSeviye = (dugum.c && dugum.c.length) ? dugum : yol[yol.length - 2];
      var wrap = el('div', { class: 'ycol__kat' });
      var sec = function (h) { state.kategori = (h === tabanKoleksiyon) ? '' : h; apply(true); };
      if (yol.length > 1) {
        var yolEl = el('div', { class: 'ycol__kat-yol' });
        yol.slice(0, -1).forEach(function (n) { var b = el('button', { type: 'button', class: 'ycol__kat-geri' }, ['‹ ' + n.t]); b.addEventListener('click', function () { sec(n.h); }); yolEl.appendChild(b); });
        wrap.appendChild(yolEl);
      }
      var grup = 'ycol-kat-' + Math.random().toString(36).slice(2, 8);
      var satir = function (n, etiket) {
        var id = grup + '-' + n.h;
        var inp = el('input', { type: 'radio', name: grup, id: id, value: n.h });
        if (n.h === secili) inp.checked = true;
        inp.addEventListener('change', function () { sec(n.h); });
        var lab = el('label', { class: 'ycol__check ycol__kat-satir', for: id }, [inp, el('span', null, [etiket || n.t]), (n.c && n.c.length) ? el('span', { class: 'ycol__kat-ok', 'aria-hidden': 'true' }, ['›']) : null]);
        return lab;
      };
      if (ustSeviye) wrap.appendChild(satir(ustSeviye, (STR.kategoriTumu || 'Tümü') + ' ' + ustSeviye.t));
      liste.forEach(function (n) { wrap.appendChild(satir(n)); });
      return wrap;
    }
    function renderFacets(facets, state, apply) {
      if (!facetsEl) return;
      var toggle = function (arr, val, on) { var i = arr.indexOf(val); if (on && i < 0) arr.push(val); if (!on && i >= 0) arr.splice(i, 1); };
      var known = {};
      facetsEl.querySelectorAll('details').forEach(function (d) { var t = d.querySelector('summary span'); if (t) known[t.textContent] = d.open; });
      /* 15 Eki 2026 (Sefa): gruplar kapalı başlar; yalnız içinde seçim olan açık gelir */
      var isOpen = function (title, def) { return title in known ? known[title] : def; };
      facetsEl.innerHTML = '';
      var add = function (title, node, def) { if (node) facetsEl.appendChild(facetBox(title, node, isOpen(title, def))); };
      if (KAT) add(STR.kategori || 'Kategori', kategoriFacet(state, apply), !!state.kategori);
      if (facets.vendors && facets.vendors.length) add(STR.vendors || 'Markalar', listFacet(facets.vendors, state.vendor, function (v, on) { toggle(state.vendor, v, on); apply(true); }), state.vendor.length > 0);
      (facets.options || []).forEach(function (opt) {
        if (fold(opt.name) === 'title') return;
        if (!state.options[opt.name]) state.options[opt.name] = [];
        var sel = state.options[opt.name];
        var cb = function (v, on) { toggle(sel, v, on); apply(true); };
        add((STR.optionNames || {})[fold(opt.name)] || opt.name, opt.presentation === 'swatch' && feat('swatches') ? swatchFacet(opt.values, sel, cb) : listFacet(opt.values, sel, cb), sel.length > 0);
      });
      if (facets.price && facets.price.max > 0) add(STR.price || 'Fiyat', priceFacet(facets.price, state, apply), !!(state.price_min || state.price_max));
      if (!CFG.hideSoldOut) add(STR.availability || 'Stok durumu', availabilityFacet(state, apply), state.available === '1');
    }

    function renderActive(state, apply) {
      if (!activeEl) return;
      activeEl.innerHTML = '';
      var chips = [];
      var addChip = function (label, remove) {
        var chip = el('button', { type: 'button', class: 'ycol__chip' });
        chip.innerHTML = '<span>' + esc(label) + '</span><svg viewBox="0 0 10 10" aria-hidden="true"><path d="m1 1 8 8M9 1 1 9" stroke="currentColor" fill="none"/></svg>';
        chip.addEventListener('click', function () { remove(); apply(true); });
        chips.push(chip);
      };
      if (state.kategori && katYol(state.kategori).length) { var ky = katYol(state.kategori); addChip(ky[ky.length - 1].t, function () { state.kategori = ''; }); }
      state.vendor.slice().forEach(function (v) { addChip(v, function () { state.vendor.splice(state.vendor.indexOf(v), 1); }); });
      state.product_type.slice().forEach(function (v) { addChip(v, function () { state.product_type.splice(state.product_type.indexOf(v), 1); }); });
      state.tag.slice().forEach(function (v) { addChip(v, function () { state.tag.splice(state.tag.indexOf(v), 1); }); });
      Object.keys(state.options).forEach(function (name) { state.options[name].slice().forEach(function (v) { addChip(v, function () { state.options[name].splice(state.options[name].indexOf(v), 1); }); }); });
      if (state.available === '1' && !CFG.hideSoldOut) addChip(STR.inStockOnly || 'Stokta', function () { state.available = ''; });
      if (state.price_min || state.price_max) addChip(currencySymbol() + (state.price_min || '0') + ' - ' + (state.price_max || '∞'), function () { state.price_min = ''; state.price_max = ''; });
      var n = activeTotal(state);
      if (activeCount) { activeCount.textContent = n ? '(' + n + ')' : ''; activeCount.hidden = !n; }
      if (!chips.length) return;
      chips.forEach(function (c) { activeEl.appendChild(c); });
      if (chips.length > 1) {
        var clear = el('button', { type: 'button', class: 'ycol__chip ycol__chip--clear' }, [STR.clearFilters || 'Filtreleri temizle']);
        clear.addEventListener('click', clearAll);
        activeEl.appendChild(clear);
      }
    }

    function renderPagination(page, pages, go) {
      pagEl.innerHTML = '';
      if (pages <= 1) { pagEl.hidden = true; return; }
      pagEl.hidden = false;
      var ul = el('ul', { class: 'pagination__list list-unstyled flex items-center flex-wrap justify-center', role: 'list' });
      var item = function (label, target, opts) {
        opts = opts || {};
        var li = el('li');
        if (opts.current) { var cur = el('a', { role: 'link', 'aria-disabled': 'true', class: 'pagination__item pagination__item--current background-2', 'aria-current': 'page' }); cur.innerHTML = label; li.appendChild(cur); return li; }
        if (opts.ellipsis) { li.appendChild(el('span', { class: 'pagination__item pagination__item--ellipsis' }, ['…'])); return li; }
        var a = el('a', { href: '#', class: 'pagination__item reversed-link' + (opts.arrow ? ' pagination__item-arrow ' + opts.arrow : ''), 'aria-label': opts.label || '' });
        a.innerHTML = opts.arrow ? label : '<span class="reversed-link__text">' + label + '</span>';
        a.addEventListener('click', function (e) { e.preventDefault(); go(target); });
        li.appendChild(a); return li;
      };
      var chevL = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><path d="m7 1-4 4 4 4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      var chevR = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><path d="m3 1 4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      if (page > 1) ul.appendChild(item(chevL, page - 1, { arrow: 'pagination__item--previous', label: STR.previous || '' }));
      var nums = new Set([1, pages, page]);
      for (var i = page - 2; i <= page + 2; i++) if (i >= 1 && i <= pages) nums.add(i);
      var sorted = Array.from(nums).sort(function (a, b) { return a - b; });
      var prev = 0;
      sorted.forEach(function (n) {
        if (n - prev > 1) ul.appendChild(item('…', null, { ellipsis: true }));
        ul.appendChild(item(String(n), n, { current: n === page, label: (STR.page || 'Sayfa __N__').replace('__N__', n) }));
        prev = n;
      });
      if (page < pages) ul.appendChild(item(chevR, page + 1, { arrow: 'pagination__item--next', label: STR.next || '' }));
      pagEl.appendChild(ul);
    }

    function clearAll() {
      var fresh = { page: 1, vendor: [], product_type: [], tag: [], options: {}, price_min: '', price_max: '', available: '', sort: readState().sort, kategori: '' };
      writeState(fresh, false);
      load(fresh, false);
    }
    var applyFrom = function (state) { return function (reset) { if (reset) state.page = 1; writeState(state, false); load(state, false); }; };

    /* 2 Eki 2026: kaydırdıkça yükleme (CFG.infiniteScroll) — sayfa sonuna gelince sonraki sayfa eklenir */
    var inf = { page: 0, pages: 0, busy: false, state: null, obs: null, sentinel: null };
    function infSetup() {
      if (!CFG.infiniteScroll || inf.sentinel || !('IntersectionObserver' in window)) return;
      inf.sentinel = el('div', { class: 'ycol__sentinel', 'aria-hidden': 'true' });
      inf.sentinel.style.cssText = 'height:1px;margin-top:-1px';
      gridEl.parentNode.insertBefore(inf.sentinel, gridEl.nextSibling);
      inf.obs = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || inf.busy || !inf.state || inf.page >= inf.pages) return;
        var next = Object.assign({}, inf.state, { page: inf.page + 1 });
        load(next, false, true);
      }, { rootMargin: '0px 0px 900px 0px' });
      inf.obs.observe(inf.sentinel);
    }

    async function load(state, push, append) {
      if (append) { if (inf.busy) return; inf.busy = true; }
      root.classList.add(append ? 'is-loading-more' : 'is-loading');
      try {
        var res = await fetch(proxy + '?' + buildQuery(state), { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('proxy ' + res.status);
        var data = await res.json();
        if (!append && !rescued && !(data.total > 0) && !(data.items || []).length && shopifyCount > 0 && activeTotal(state) === 0) {
          rescued = true;
          if (singleVendor && !fixedVendor) {
            fixedVendor = singleVendor; collection = 'all';
            console.warn('[yake] sunucu koleksiyonu tanımıyor, marka sorgusuna geçildi:', singleVendor);
            return load(state, push, append);
          }
          throw new Error('sunucu 0 ürün döndü, Shopify\'da ' + shopifyCount + ' ürün var');
        }
        if (data.features) FEATURES = data.features;
        applyFeatureVisibility();
        renderGrid(data.items || [], append);
        if (CFG.infiniteScroll) {
          inf.page = data.page || state.page || 1; inf.pages = data.pages || 1; inf.state = state;
          infSetup();
        }
        if (append) return;
        if (feat('facets') && data.facets) renderFacets(data.facets, state, applyFrom(state));
        renderActive(state, applyFrom(state));
        if (CFG.infiniteScroll) { pagEl.innerHTML = ''; pagEl.hidden = true; }
        else renderPagination(data.page || 1, data.pages || 1, function (t) {
          state.page = t; writeState(state, true); load(state, true);
          window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        });
        if (countEl) countEl.textContent = productsCountText(data.total || 0);
        if (sortSelect && state.sort) sortSelect.value = state.sort;
      } catch (err) {
        console.warn('[yake] backend listelemesi başarısız, tema listesi kullanılıyor:', err.message);
        /* 15 Eki 2026: liste sunucusu yoksa (ör. /collections/all) filtre çekmecesi boş açılıyordu → butonu gizle */
        if (!append && filterToggle && facetsEl && !facetsEl.children.length) filterToggle.hidden = true;
      } finally {
        root.classList.remove('is-loading');
        root.classList.remove('is-loading-more');
        root.classList.remove('is-booting');
        if (append) {
          inf.busy = false;
          /* ekran hâlâ dolmadıysa (ör. büyük ekran) bir sonrakini de iste */
          if (inf.sentinel && inf.page < inf.pages && inf.sentinel.getBoundingClientRect().top < window.innerHeight + 900) {
            load(Object.assign({}, inf.state, { page: inf.page + 1 }), false, true);
          }
        }
      }
    }

    if (sortSelect) sortSelect.addEventListener('change', function () {
      var s = readState(); s.sort = sortSelect.value; s.page = 1; writeState(s, true); load(s, true);
    });
    if (clearBtn) clearBtn.addEventListener('click', clearAll);

    function applyFeatureVisibility() {
      if (sortWrap) sortWrap.hidden = !feat('sortMenu');
      if (filterToggle) filterToggle.hidden = !feat('facets');
      if (feat('backendFavorites') && CFG.loggedIn && !favLoaded) {
        favLoaded = true;
        fetch(favBase + '/favorites', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) { favSet = new Set(d.ids || []); markHearts(root); }).catch(function () {});
      }
    }

    window.addEventListener('popstate', function () { load(readState(), false); });
    var initial = readState();
    if (sortSelect && initial.sort) sortSelect.value = initial.sort;
    load(initial, false);
  }

  function boot() { document.querySelectorAll('[data-yake-collection]').forEach(initContainer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
